module.exports = __webpack_public_path__ + "static/Marianne.1b4ee917.jpeg";


//////////////////
// WEBPACK FOOTER
// /opt/build/repo/src/assets/team/Marianne.jpeg
// module id = 938
// module chunks = 3